import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { onGetOrgusers } from "../services/auth/organization";
import { useStateGetter } from "./statehooks/UseStateGettersHook";
import { useStateSetter } from "./statehooks/UseStateSettersHook";
import { toast } from "react-toastify";
import { onGetOrgModules } from "../services/auth/modules";
import { useParams } from "react-router-dom";

const useOrganizationHook = () => {
  var SelectedOrg = useSelector((state: any) => state.SelectedOrg);
  const [UserOrgs, setUserOrgs] = useState<any[]>([]);
  const [selectedOrgModules, setselectedOrgModules] = useState<any[]>();
  const {orgid}=useParams()

  const { config } = useStateGetter();
  const { setLoading } = useStateSetter();

  const Getusserorg = async () => {
    setLoading(true);
    try {
      var response = await onGetOrgusers(config);
      const emptyarrOrg: any[] = [];
      response.data.map((item: any) => {
        emptyarrOrg.push(item.organization);
      });

      setUserOrgs(emptyarrOrg);
      setLoading(false);
    } catch (e: any) {
      console.log(e);
      setLoading(false);
      toast.error(e);
    }
  };
useEffect(()=>console.log(UserOrgs),[UserOrgs]
)
  const getModules = async () => {
    setLoading(true);
    try {
      var response = await onGetOrgModules(SelectedOrg.id??orgid, config);
      const emptyarrModules: any[] = [];
      response.data.map((item: any) => {
        emptyarrModules.push(item.module);
      });

      setselectedOrgModules(emptyarrModules)
setLoading(false)
    } catch (e: any) {
      console.log(e);
    //   toast.error(e);
      setLoading(false)
    }
  };


  const init= async ()=>{

    await Getusserorg();
   await  getModules()
  }
  useEffect(() => {
 init()
  }, []);

  return { UserOrgs, SelectedOrg , selectedOrgModules};
};

export { useOrganizationHook };
